module.exports = __webpack_public_path__ + "637d1f25ffbe3d31b315fb2352c6fab1.png";